import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from './Navbar/NavBar';
import heroImg from '../images/demo/heroimg.jpeg';

const Hero = () => {
    return (
        <>
            <div className="relative h-screen w-full" id="hero">
                {/* Background Image */}
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${heroImg})` }}
                ></div>

                {/* Black Overlay */}
                <div className="absolute inset-0 bg-black opacity-60"></div>

                {/* Navbar (stays on top) */}
                <div className="relative z-20">
                    <NavBar />
                </div>

                {/* Hero Content */}
                <div className="relative z-10 flex items-center justify-center h-full px-4 md:px-12">
                    <div className="text-center max-w-3xl text-white" data-aos="zoom-in">
                        <h1 className="text-4xl md:text-6xl font-bold mb-6">
                            Precision. Presentation. Perfection.
                        </h1>
                        <p className="text-lg md:text-xl mb-8 font-medium text-gray-200">
                            Empowering cosmetic and lifestyle brands with world-class packaging and offset printing — designed, developed, and delivered under one roof.
                        </p>
                        <div className="flex flex-col sm:flex-row justify-center gap-4">
                            {/* <Link
                                to="/get-demo#demo"
                                // className="bg-white text-black px-6 py-3 rounded-lg font-semibold hover:bg-gray-200 transition"
                                className='border border-white text-white px-6 py-3 rounded-lg font-semibold hover:bg-white hover:text-black transition'
                            >
                                Request a Quote
                            </Link> */}
                            {/* <Link
                                to="/services"
                                className="border border-white text-white px-6 py-3 rounded-lg font-semibold hover:bg-white hover:text-black transition"
                            >
                                Explore Services
                            </Link> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Hero;